import { TermsAndConditions } from '@wix/app-market-components';
import React from 'react';
import type { getAppPageDataResponse } from '../../app-page-api';
import { useEssentials } from '@wix/app-market-core';
import type { AppPageType } from '@wix/app-market-core-components-types';
import { appMarketAppPageClick } from '@wix/bi-logger-app-market-data/v2';

interface AppModalContentPermissionsProps {
  appModalData: getAppPageDataResponse;
  languageCode: string;
  appPageType: AppPageType;
}
const AppModalContentPermissions = ({
  appModalData,
  languageCode,
  appPageType,
}: AppModalContentPermissionsProps) => {
  const { biLogger } = useEssentials();

  const onTermsAndConditionsClick = (link: string) => {
    biLogger.report(
      appMarketAppPageClick({
        app_id: appModalData.app.id,
        cta: 'terms_of_use',
        location: 'slim_app_page',
        app_page_type: appPageType,
      }),
    );
    window.open(link);
  };

  const onPrivacyPolicyClick = (link: string) => {
    biLogger.report(
      appMarketAppPageClick({
        app_id: appModalData.app.id,
        cta: 'privacy_policy',
        location: 'slim_app_page',
        app_page_type: appPageType,
      }),
    );
    window.open(link);
  };

  const termsAndConditionsProps = {
    appName: appModalData.app.name ?? '',
    companyName: appModalData.companyInfo.name,
    termsOfUseUrl: appModalData.app.termsOfUseUrl,
    privacyPolicyUrl: appModalData.companyInfo.privacyPolicyUrl,
    isInstalled: appModalData.app.installation.isInstalled,
    languageCode,
    onTermsAndConditionsClick,
    onPrivacyPolicyClick,
  };

  return (
    <div>
      {appModalData.app.isSelfPublished && (
        <>
          <TermsAndConditions {...termsAndConditionsProps} isSelfPublished />{' '}
        </>
      )}
      <TermsAndConditions {...termsAndConditionsProps} />
    </div>
  );
};

export default AppModalContentPermissions;
